import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import './index.css';
import App from './App';
import store from './redux/store';
import { Provider } from 'react-redux';
import {BrowserRouter as Router} from 'react-router-dom';
import { GoogleOAuthProvider } from "@react-oauth/google"


ReactDOM.render(
    <Provider store={store}>
        <Router>
            <GoogleOAuthProvider clientId='286246847686-u1iuknb031rjb6t35rodie77mps8rl70.apps.googleusercontent.com'>
                <React.StrictMode>
                    <App />
                </React.StrictMode>
            </GoogleOAuthProvider>
        </Router>
    </Provider>,
    document.getElementById('root')
);

serviceWorker.unregister();
